module.exports = __webpack_public_path__ + "img/laba.d0c72859.svg";